import System from '../basic/System';
import { ThemeList } from './ThemeList';

import './ThemeImages.css';

class ThemeSetupClass {
  static BASE_THEME_CLASS: string = 'theme_';
  _name: string;
  constructor() {
    this._name = System.getTheme().getName();
  }

  updateTheme = (): void => {
    const currentTheme = System.getTheme();
    this._name = currentTheme.getName();
    const themeSettings = ThemeList[this._name];

    document.body.className = ThemeSetupClass.BASE_THEME_CLASS + this._name;
    Object.keys(themeSettings).forEach((key) => {
      document.body.style.setProperty(key, themeSettings[key]);
    });
  };

  getName = (): string => {
    return this._name;
  };

  getBackgroundURL = (imageName: string): string => {
    return `url(images/themes/${this._name}/${imageName})`;
  };

  getImageURL = (imageName: string): string => {
    return `images/themes/${this._name}/${imageName}`;
  };
}

export const ThemeSetup = new ThemeSetupClass();
